import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02df1f17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "header-pfnr" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " : ", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "pdf-container" }
const _hoisted_7 = { class: "block2" }
const _hoisted_8 = { class: "question" }
const _hoisted_9 = { class: "question-text" }
const _hoisted_10 = { class: "agree-checkbox" }
const _hoisted_11 = { class: "agree-text" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "contact-info" }
const _hoisted_14 = { class: "contact-text" }
const _hoisted_15 = { class: "person-info-container" }
const _hoisted_16 = { class: "person-details" }
const _hoisted_17 = { class: "detail-name" }
const _hoisted_18 = { class: "detail-email" }
const _hoisted_19 = { class: "detail-phone" }
const _hoisted_20 = { class: "button-container" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_PdfApp = _resolveComponent("PdfApp")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("strong", null, [
            _createVNode(_component_i18n_t, { keypath: "orderApprovePopup.proformaNumber" })
          ]),
          _hoisted_4,
          (
                            _ctx.approveOrders?.[0]?.backoffice_reference == undefined ||
                            _ctx.approveOrders?.[0]?.backoffice_reference == null
                        )
            ? (_openBlock(), _createBlock(_component_i18n_t, {
                key: 0,
                keypath: "myOrders.notYetAvailable"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.approveOrders?.[0]?.backoffice_reference), 1)),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: "/img/close-btn.svg",
              class: "close-popup-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(_component_PdfApp, {
            onPagesRendered: _ctx.pagesRendered,
            "page-number": _ctx.pdfPage,
            pdf: _ctx.pdf,
            pageScale: "page-height",
            style: {"height":"100vh","width":"80vh"},
            config: _ctx.pdfConfig
          }, null, 8, ["onPagesRendered", "page-number", "pdf", "config"]), [
            [_vShow, _ctx.pdf !== '']
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_i18n_t, { keypath: "orderApprovePopup.approveQuestion" })
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.isAgree,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAgree) = $event)),
              binary: true,
              onChange: _ctx.isAgree,
              disabled: !_ctx.isFinishedViewingPdf
            }, null, 8, ["modelValue", "onChange", "disabled"]),
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_i18n_t, { keypath: "orderApprovePopup.checkBoxText" })
            ])
          ])), [
            [_directive_tippy, {
                            content: _ctx.i18n.t('myOrders.checkBoxTip'),
                            placement: 'top',
                        }]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_i18n_t, { keypath: "orderApprovePopup.contactInfo" })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(`${_ctx.approveOrders?.[0]?.account_manager?.firstname} ${_ctx.approveOrders?.[0]?.account_manager?.lastname}`), 1),
              _createElementVNode("div", _hoisted_18, " Email: " + _toDisplayString(_ctx.approveOrders?.[0]?.account_manager?.email), 1),
              _createElementVNode("div", _hoisted_19, " Phone: " + _toDisplayString(_ctx.approveOrders?.[0]?.account_manager?.phone), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "cancel-button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
              }, [
                _createVNode(_component_i18n_t, { keypath: "orderApprovePopup.cancelButton" })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: !_ctx.isAgree,
                class: _normalizeClass([{ 'app-disabled': !_ctx.isAgree }, "approve-button uppercase"]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.approve()))
              }, [
                _createVNode(_component_i18n_t, { keypath: "orderApprovePopup.approveButton" })
              ], 10, _hoisted_21)
            ])
          ])
        ])
      ])
    ])
  ]))
}